module.exports = __webpack_public_path__ + "img/david.5ac485c3.jpg";